:host {
  font-size: 5rem;
}

.title-heading {
  font-weight: 450;
  font-size: inherit;
  line-height: 1;
  margin: 0;
  display: flex;
}

.title-left,
.title-right {
  display: block;
}

.title-left {
  text-align: right;
  padding-inline: 0 0.05em;
  background-image: linear-gradient(to top, var(--fg-lit), var(--fg) 40%, var(--fg) 60%, var(--fg-dim));
  color: transparent;
  background-clip: text;
}

.title-right {
  text-align: left;
  color: var(--bg);
  text-shadow:
    -0.01em 0.01em 0.0125em hsla(var(--fg-hsl-lit), 0.5),
    0.01em -0.01em 0.0125em hsla(var(--fg-hsl-dim), 0.75);
  background-image: linear-gradient(to bottom, var(--fg-lit), var(--fg) 40%, var(--fg) 60%, var(--fg-dim));
  padding-inline: 0.05em 0.1125em;
  letter-spacing: -3%;
}
